import React from 'react';
import { Helmet } from 'react-helmet';

interface SEORatingProps {
  ratingValue: string;
  reviewCount: string;
  URL: string;
}

const SEORating = ({ ratingValue, reviewCount, URL }: SEORatingProps) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {`{"@context":"http://schema.org/",
      "@type":"MobileApplication",
      "name":"MakeMyTrip",
      "aggregateRating":{"@type":"AggregateRating","ratingValue":${ratingValue},"reviewCount":${reviewCount}},
      "applicationCategory":"Travel",
      "URL": "${URL}",
      "operatingSystem":"Android, iOS"}`}
      </script>
    </Helmet>
  );
};

export default SEORating;
